module.exports = __webpack_public_path__ + "img/chili.5749d833.svg";